const signupStore = {
	namespaced: true,
	state: {
		userSms: 0,
		userMailing: 0,
		userName: '',
	},
	getters: {},
	mutations: {
		setUserSms(state, data) {
			state.userSms = data;
		},
		setUserMailing(state, data) {
			state.userMailing = data;
		},
		setUserName(state, data) {
			state.userName = data;
		},
		resetState(state) {
			state.userSms = 0;
			state.userMailing = 0;
			state.userName = '';
		},
	},
};

export default signupStore;
